import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

const ITEMS = [
  { value: 10, suffix: "+", label: "Courier Integrations" },
  { value: 27000, suffix: "+", label: "Pan-India Pincodes", format: (v) => `${Math.round(v / 1000)},000`.replace("27,000", "27,000") },
  { value: 2, suffix: "", label: "Domestic & International", format: (v) => (v >= 2 ? "Dom + Intl" : "Dom") },
  { value: 24, suffix: "×7", label: "Real-Time Tracking" },
  { value: 100, suffix: "%", label: "COD Support" },
  { value: 6, suffix: "", label: "Smart Selection Signals" },
];

function Counter({ item, start }) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!start) return;
    let raf; const t0 = performance.now(); const dur = 1600;
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / dur);
      setVal(item.value * (1 - Math.pow(1 - p, 3)));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [start, item.value]);
  const display = item.format ? item.format(val) : Math.round(val).toLocaleString("en-IN");
  return (
    <div className="text-center" data-testid={`trust-${item.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
      <p className="mono font-display text-2xl font-extrabold text-white sm:text-3xl">
        <span className="text-saffron-green">{display}{item.suffix}</span>
      </p>
      <p className="mt-1.5 text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-400 sm:text-xs">{item.label}</p>
    </div>
  );
}

export default function TrustStrip() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  return (
    <section ref={ref} className="relative border-y border-white/10 bg-[#030B18]" data-testid="trust-strip">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#FF9933]/60 to-transparent" />
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-8 px-5 py-10 sm:grid-cols-3 lg:grid-cols-6">
        {ITEMS.map((item) => <Counter key={item.label} item={item} start={inView} />)}
      </div>
    </section>
  );
}
